import FormularDenuncia from './FormularDenuncia';

export default FormularDenuncia;
